// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sRugc","colMin":"styles_colMin__mMbUT"};